import { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'components/common/icons';
import { Form, Text } from 'components/common/form';

const SearchForm = connect((state) => ({
  messages: state.messages,
  theme: state.theme
}))(
  class extends Component {
    state = {
      loading: false,
      search: Boolean(this.props.initialValue)
    };

    componentDidMount() {
      if (this.props.setSearchForm) this.props.setSearchForm(this);
    }

    setFormApi = (formApi) => {
      this.formApi = formApi;
      if (this.props.setFormApi) this.props.setFormApi(formApi);
    };

    clearForm = async () => {
      const { dispatch, onClear } = this.props;

      this.formApi.reset();
      this.formApi.setValue('search', '');

      this.setState({ loading: false, search: false });

      try {
        await onClear();
      } catch (err) {
        await dispatch.handleErrorDispatch(err);
      }
    };

    submitForm = async (values) => {
      const { onError, onSearch } = this.props;

      if (!values.search) return;

      this.setState({ loading: true, search: true });

      try {
        await onSearch(encodeURIComponent(values.search));
        this.setState({ loading: false });
      } catch (err) {
        this.setState({ loading: false });
        await onError(err);
      }
    };

    render() {
      const {
        darkMode,
        disabled,
        initialValue,
        messages,
        onChange,
        placeholderText,
        size,
        theme,
        validate,
        validateOnChange
      } = this.props;

      const { loading, search } = this.state;

      let iconColor = '#999';
      let iconColorActive = theme.textColor;
      if (darkMode) {
        iconColor = '#aaa';
        iconColorActive = '#fff';
      }

      const inputStyle = {
        ...(size === 'header' ? { padding: '4px 10px 5px' } : {}),
        paddingRight: search ? 65 : 35
      };

      return (
        <div className="search">
          <Form getApi={this.setFormApi} onSubmit={this.submitForm}>
            {({ formState }) => (
              <div className="wrapper">
                <div className="input-wrapper">
                  <Text
                    aria-label={messages.commonSearch}
                    darkMode={darkMode}
                    disabled={disabled}
                    error={formState?.errors?.search}
                    field="search"
                    initialValue={initialValue}
                    inputStyle={inputStyle}
                    loading={loading}
                    onChange={onChange}
                    placeholder={placeholderText}
                    showErrorIcon={false}
                    validate={validate}
                    validateOnChange={validateOnChange}
                  />

                  {!loading ? (
                    <button
                      aria-label={messages.commonSearch}
                      className="search-button"
                      disabled={disabled}
                      type="submit"
                    >
                      <Icon icon="search" />
                    </button>
                  ) : null}

                  {search ? (
                    <button
                      aria-label={messages.commonClear}
                      className="clear-button"
                      onClick={this.clearForm}
                      type="button"
                    >
                      <Icon icon="times-circle" />
                    </button>
                  ) : null}
                </div>
              </div>
            )}
          </Form>

          <style jsx>{`
            .wrapper {
              display: flex;
            }
            .input-wrapper {
              display: inline-block;
              max-width: 320px;
              width: 100%;
              position: relative;
            }
            .clear-button,
            .search-button {
              background-color: transparent;
              border: 0;
              color: ${iconColor};
              cursor: pointer;
              height: ${size === 'header' ? '28px' : '33px'};
              outline: 0;
              padding: 0;
              position: absolute;
              text-align: center;
              top: 1px;
              transition: color 0.3s;
              width: 30px;
            }
            .clear-button:hover,
            .clear-button:focus,
            .search-button:hover,
            .search-button:focus {
              color: ${iconColorActive};
            }
            .search-button {
              font-size: 1.1rem;
              right: 5px;
            }
            .clear-button {
              font-size: 1.3rem;
              right: 34px;
            }
          `}</style>
        </div>
      );
    }
  }
);

export default SearchForm;
